export default {
  'purchaseImport.form.xmlRecipient': 'XML Recipient',
  'purchaseImport.form.xmlIssuer': 'XML Issuer',
  'purchaseImport.form.linkToExistingPurchase': 'Link to existing purchase',

  'purchaseImport.error.incompatibleCompany':
    'The CNPJ informed is incompatible with the registered company',

  'purchaseImport.form.company': 'Company',
  'purchaseImport.form.invoiceKey': 'Invoice key',
  'purchaseImport.form.supplier': 'Supplier',
  'purchaseImport.form.invoiceNumber': 'Invoice number',
  'purchaseImport.form.model': 'Model',
  'purchaseImport.form.series': 'Series',
  'purchaseImport.form.emissionDate': 'Emission date',
  'purchaseImport.form.departureDate': 'Departure date',
  'purchaseImport.form.noteValue': 'Note value',

  'purchaseImport.form.message.error': 'Import a file',
  'purchaseImport.form.message.upload': 'Select a file to import',
  'purchaseImport.form.message.import': 'Import',
};
